import React from "react";
import styled, { useTheme } from "styled-components";


const CircularProgress = ({
    count,
    total,
    size = 38,
    strokeWidth = 5,
}) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const progress = total > 0 ? count / total : 0;
    const offset = circumference - progress * circumference;
    const theme = useTheme();

    return (
        <div className="d-flex align-items-center justify-content-center position-relative">
            <svg width={size} height={size} style={{ transform: "rotate(270deg)" }}>
                {/* Background circle */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke="#e5e7eb" // light gray
                    strokeWidth={strokeWidth}
                    fill="transparent"
                />

                {/* Progress circle */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke={theme?.secondary}
                    strokeWidth={strokeWidth}
                    fill="transparent"
                    strokeDasharray={circumference}
                    strokeDashoffset={count === 0 ? 103 : offset}
                    strokeLinecap="round"
                    className="transition-all duration-500 ease-in-out"
                />
            </svg>

            {/* Text in center */}
            <StyledText >
                {count}/{total}
            </StyledText>
        </div>
    );
};

export default CircularProgress;


const StyledText = styled.div`
position:absolute;
font-family:Fredoka;
font-weight:500;
color:${({ theme }) => theme?.primary};


`